export default __webpack_public_path__ + "static/media/pa_6.922d776c.mp3";